import {ListGroup} from "react-bootstrap";
import React, {useState} from "react";

const TreeSection = ({sections, onLoadProduct}) => {

    const [show, setShow] = useState([]);

    return (
        <div className="row">
            {sections.map(item => {
                return (
                    <>
                        <div className="row border-bottom" key={item.ID}>
                            {item.children && (show.find(key => key === item.ID) ? (
                                <span className="col-1 group-minus" onClick={() => {
                                    setShow(show.filter(key => key !== item.ID))
                                }}>-</span>
                            ) : (
                                <span className="col-1 group-minus" onClick={() => {
                                    setShow([...show, item.ID])
                                }}>+</span>
                            ))}
                            <span className="col" onClick={() => {
                                onLoadProduct(item.children_section_id ? [...item.children_section_id, item.ID] : item.ID)
                            }}>
                                {item.NAME}
                            </span>
                        </div>
                        {item.children && show.find(key => key === item.ID) && (
                            <div className="row border-bottom ps-5">
                                <TreeSection sections={item.children} onLoadProduct={onLoadProduct}/>
                            </div>
                        )}
                    </>
                )
            })}
        </div>
    )

    return (
        <ListGroup>
            {sections.map(item => {
                return (
                    <>
                        <ListGroup.Item key={item.ID} onClick={() => {

                        }}>
                            {item.children && (show.find(key => key === item.ID) ? (
                                <span className="group-minus" onClick={() => {
                                    setShow(show.filter(key => key !== item.ID))
                                }}>-</span>
                            ) : (
                                <span className="group-minus" onClick={() => {
                                    setShow([...show, item.ID])
                                }}>+</span>
                            ))}
                            {item.NAME}
                        </ListGroup.Item>
                        {item.children && show.find(key => key === item.ID) && (
                            <div style={{paddingLeft: "25px"}}>
                                <TreeSection sections={item.children}/>
                            </div>
                        )}
                    </>
                )
            })}
        </ListGroup>
    )
}

export default TreeSection